
export const fun_comma = {

    comma : function (str) {
        str = String(str);
        return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    },
    
    uncomma : function (str) {
        str = String(str);
        return str.replace(/[^\d]+/g, '');
    }
}

export default fun_comma
